<!-- Sidenav Component -->
<a>
  <img src="../../../../../assets/images/AllyLogoLight.svg" alt="AndDone Ally" />
</a>

<span class="ally-name">{{ this.allyName }}</span>

<!-- Bootstrap NavBar -->

<ul class="nav-list">
  <li class="nav-link">
    <a
      tabindex="-1"
      [routerLinkActive]="['active']"
      [routerLinkActiveOptions]="{ exact: false }"
      [routerLink]="['/ally/users']"
      [queryParamsHandling]="'preserve'"
    >
      <img src="../../../../../assets/images/UsersIcon.svg" alt="Users" />
      {{ 'sideNav.users' | translate }}
    </a>
  </li>
  <li class="nav-link">
    <a
      [routerLinkActive]="['active']"
      [routerLinkActiveOptions]="{ exact: false }"
      [routerLink]="['/ally/payments']"
      [queryParamsHandling]="'preserve'"
    >
      <img src="../../../../../assets/images/payments.svg" alt="Payments" />
      {{ 'sideNav.payments' | translate }}
    </a>
  </li>
  <li class="nav-link">
    <a
      [routerLinkActive]="['active']"
      [routerLinkActiveOptions]="{ exact: false }"
      [routerLink]="['/ally/reports']"
      [queryParamsHandling]="'preserve'"
    >
      <img src="../../../../../assets/images/ReportingIcon.svg" alt="Webhooks" />
      {{ 'sideNav.reporting' | translate }}
    </a>
  </li>
  <li class="nav-link">
    <a
      [routerLinkActive]="['active']"
      [routerLinkActiveOptions]="{ exact: false }"
      [routerLink]="['/ally/notifications']"
      [queryParamsHandling]="'preserve'"
    >
      <img src="../../../../assets/images/notifications.svg" alt="Notifications" />
      {{ 'sideNav.notifications' | translate }}
    </a>
  </li>
  <li class="nav-link">
    <a
      [routerLinkActive]="['active']"
      [routerLinkActiveOptions]="{ exact: false }"
      [routerLink]="['/ally/webhooks']"
      [queryParamsHandling]="'preserve'"
    >
      <img src="../../../../../assets/images/WebhooksIcon.svg" alt="Webhooks" />
      {{ 'sideNav.webhooks' | translate }}
    </a>
  </li>
  <li class="nav-link">
    <a
      [routerLinkActive]="['active']"
      [routerLinkActiveOptions]="{ exact: false }"
      [routerLink]="['/ally/webhook-events']"
      [queryParamsHandling]="'preserve'"
    >
      <img src="../../../../../assets/images/WebhookEventsIcon.svg" alt="Webhook Events" />
      {{ 'sideNav.webhookEvents' | translate }}
    </a>
  </li>
</ul>

<div class="sidebar-bottom">
  <div class="dropdown" ngbDropdown>
    <div class="profile-link" ngbDropdownToggle>
      <div class="profile-icon">{{ shortName }}</div>
      <p class="profile-name">{{ userName }}</p>
    </div>
    <ul class="dropdown-menu" ngbDropdownMenu>
      <li ngbDropdownItem (click)="linkToProfile()" tabindex="0" (keydown.enter)="linkToProfile()">
        <a>Profile</a>
      </li>
      <li ngbDropdownItem>
        <a (click)="logOut()">Log Out</a>
      </li>
    </ul>
  </div>
</div>
